import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const coursesBlockFn = /* @__PURE__ */ createRecipe('courses-block', {}, [])

const coursesBlockVariantMap = {}

const coursesBlockVariantKeys = Object.keys(coursesBlockVariantMap)

export const coursesBlock = /* @__PURE__ */ Object.assign(memo(coursesBlockFn.recipeFn), {
  __recipe__: true,
  __name__: 'coursesBlock',
  __getCompoundVariantCss__: coursesBlockFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: coursesBlockVariantKeys,
  variantMap: coursesBlockVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, coursesBlockVariantKeys)
  },
  getVariantProps: coursesBlockFn.getVariantProps,
})